import React from 'react';
import { Button, Stack, Text } from '@adc/parallax-component-library';
import { RichText } from 'Components/utility';
import i18n from 'Utilities/i18n';
const Content = ({ email, onButtonPress }) => {
    return (React.createElement(Stack, null,
        React.createElement(Stack, null,
            React.createElement(RichText, { testID: "CheckYourEmailRegistration.subtitle", text: i18n.t('CheckYourEmailRegistration.subtitle', {
                    emailAddress: email,
                }) })),
        React.createElement(Stack, { marginTop: "$4" },
            React.createElement("img", { src: i18n.t('CheckYourEmailRegistration.content.checkYourEmail.media.checkYourEmail'), alt: "", style: {
                    objectFit: 'contain',
                    height: 205,
                }, id: "CheckYourEmailRegistration.check-email-img" })),
        React.createElement(Stack, { gap: "$4", marginTop: "$3" },
            React.createElement(Text, { textAlign: "center", testID: "CheckYourEmailRegistration.primaryText" }, i18n.t('CheckYourEmailRegistration.content.checkYourEmail.primaryText')),
            React.createElement(Stack, { flexDirection: "row", justifyContent: "center" },
                React.createElement(Button, { variant: "tertiary", label: i18n.t('CheckYourEmailRegistration.content.checkYourEmail.links.resendEmail.label'), "aria-label": i18n.t('CheckYourEmailRegistration.content.checkYourEmail.links.resendEmail.label'), onPress: onButtonPress, testID: "CheckYourEmailRegistration.resendEmail-btn" })))));
};
export default Content;
